define("SC.ManorThemeExtension.ApplicationSkeleton.Layout", [
  "SC.ManorThemeExtension.Common.Configuration",
  "SC.ManorThemeExtension.Common.UtilitiesHelper",
], function QSApplicationSkeletonLayout(Configuration, Utils) {
  "use strict";
  return {
    loadModule: function loadModule() {
      jQuery(window).scroll(function () {        
        var y = jQuery(this).scrollTop();
        //Mobile fixed header is not optional, so we'll run it from outside the fixedHeader conditional.
        if ($(window).width() < 768) {//checking the screen-size
          if (jQuery('header').hasClass('checkout-layout-header')) {
            //do nothing
          } else {
            if (y >= 100 && y < 200) {//the header is a lot smaller, so we'll set a 100points scroll instead of 300
              jQuery('body').addClass('fixed-header-mobile');
              jQuery('#main-container').css('padding-top',  jQuery('#site-header').outerHeight(true));
            }
            if (y < 99) {
              jQuery('#main-container').css('padding-top', 0);
              jQuery('body').removeClass('fixed-header-mobile');
            }
          }
        }
      });
    }
  };
});
